"use client";

import Image from "next/image";
import { Link } from "@/navigation";
import { useTranslations } from "next-intl";

// 箭头图标
const ArrowIcon = () => (
	<svg
		className="h-4 w-4 transition-transform group-hover:translate-x-1"
		viewBox="0 0 20 20"
		fill="none"
		stroke="currentColor"
		strokeWidth="2"
	>
		<path d="M5 10h10M12 6l4 4-4 4" strokeLinecap="round" strokeLinejoin="round" />
	</svg>
);

export default function Intro() {
	const t = useTranslations("fiveAxisIntroCompare");

	return (
		<section className="w-full bg-white py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				{/* 第一部分：Simultaneous 5 Axis vs 3+2 Axis */}
				<div className="mb-12 md:mb-16">
					{/* 内容区：左文字右图片 */}
					<div className="flex flex-col gap-8 lg:flex-row lg:items-start lg:gap-12 xl:gap-16">
						{/* 左侧文字 */}
						<div className="w-full lg:w-1/2">
							{/* Simultaneous 5-Axis */}
							<div className="mb-8">
								{/* 标题 */}
								<h2 className="mb-6 text-2xl font-bold leading-tight text-black sm:mb-8 sm:text-[30px] md:mb-10 md:text-4xl lg:mb-12">
									{t("section1Title")}
								</h2>
								<h3 className="mb-3 text-lg font-bold text-black decoration-1 underline-offset-4 sm:text-xl md:text-2xl">
									{t("simultaneous5AxisTitle")}
								</h3>
								<p className="text-sm leading-relaxed text-black md:text-base">
									{t("simultaneous5AxisDesc")}
								</p>
							</div>

							{/* 3+2 Axis */}
							<div>
								<h3 className="mb-3 text-lg font-bold text-black sm:text-xl md:text-2xl">
									{t("threeTwoAxisTitle")}
								</h3>
								<p className="text-sm leading-relaxed text-black md:text-base">{t("threeTwoAxisDesc")}</p>
							</div>
						</div>

						{/* 右侧图片 */}
						<div className="w-full lg:w-1/2">
							<div className="relative aspect-[4/3] w-full overflow-hidden">
								<Image
									src="/image/new-version/machining/five-axis/case/dr-park-collaborates-with-js-precision-to-advance-orthopedic-rehabilitation-technology.webp"
									alt={t("section1ImageAlt")}
									fill
									className="object-cover"
									sizes="(max-width: 1024px) 100vw, 50vw"
								/>
							</div>
						</div>
					</div>
				</div>

				{/* 第二部分：Trunnion-Style vs. Swivel-Rotate-Style */}
				<div className="mb-12 md:mb-16">
					{/* 内容区：左图片右文字 */}
					<div className="flex flex-col gap-8 lg:flex-row lg:items-start lg:gap-12 xl:gap-16">
						{/* 左侧图片 */}
						<div className="order-2 w-full lg:order-1 lg:w-1/2">
							<div className="relative aspect-[4/3] w-full overflow-hidden">
								<Image
									src="/image/new-version/machining/five-axis/intro/trunnion-style-vs-swivel-rotate-style-5-axis-machining.webp"
									alt={t("section2ImageAlt")}
									fill
									className="object-cover"
									sizes="(max-width: 1024px) 100vw, 50vw"
								/>
							</div>
						</div>

						{/* 右侧文字 */}
						<div className="order-1 w-full lg:order-2 lg:w-1/2">
							{/* 标题 */}
							<h2 className="mb-6 text-2xl font-bold leading-tight text-black sm:mb-8 sm:text-[30px] md:mb-10 md:text-4xl lg:mb-12">
								{t("section2Title")}
							</h2>

							{/* Trunnion-Style */}
							<div className="mb-8">
								<h3 className="mb-3 text-lg font-bold text-black sm:text-xl md:text-2xl">
									{t("trunnionStyleTitle")}
								</h3>
								<p className="text-sm leading-relaxed text-black md:text-base">{t("trunnionStyleDesc")}</p>
							</div>

							{/* Swivel-Rotate-Style */}
							<div>
								<h3 className="mb-3 text-lg font-bold text-black sm:text-xl md:text-2xl">
									{t("swivelRotateStyleTitle")}
								</h3>
								<p className="text-sm leading-relaxed text-black md:text-base">
									{t("swivelRotateStyleDesc")}
								</p>
							</div>
						</div>
					</div>
				</div>

				{/* 行动号召区域 */}
				<div className="flex flex-col items-center justify-between gap-6 sm:flex-row sm:gap-4">
					<p className="text-sm leading-relaxed text-black md:text-base">{t("ctaText")}</p>
					<Link
						href="/upload"
						className="group inline-flex items-center justify-center gap-2 rounded bg-themePrimary400 px-6 py-3 text-sm font-medium text-white transition-all duration-300 hover:bg-opacity-80 hover:text-white md:px-8 md:py-3.5 md:text-base"
					>
						{t("ctaButton")}
						<ArrowIcon />
					</Link>
				</div>
			</div>
		</section>
	);
}
